import { render, staticRenderFns } from "./IconFurniture.vue?vue&type=template&id=1fc19fa8&"
import script from "./IconFurniture.vue?vue&type=script&lang=js&"
export * from "./IconFurniture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports